import GenericDataTable, {
  GenericDataTableProps,
} from "../../DataTable/DataTable";
import CrudHeader, { CrudHeaderProps } from "./CrudHeader";
import CrudMapView from "./CrudMapView";

type CrudViewProps<T> = GenericDataTableProps<T> &
  CrudHeaderProps & {
    header?: React.ReactNode;
    mode?: "table" | "cards" | "map";
    getMarkerPosition?: (item: T) => { lat: number; lng: number } | null;
    getMarkerLabel?: (item: T) => string;
    viewToggle?: React.ReactNode;
  };

function CrudContent<T extends Record<string, any>>({
  mode,
  getMarkerPosition,
  getMarkerLabel,
  ...props
}: CrudViewProps<T>) {
  switch (mode) {
    case "table":
      return <GenericDataTable<T> {...props} />;
    case "cards":
      return <div>CRUD Content</div>;
    case "map":
      return (
        <CrudMapView
          data={props.data}
          getMarkerPosition={getMarkerPosition}
          getMarkerLabel={getMarkerLabel}
          onMarkerClick={props.onRowClick}
        />
      );
    default:
      return <GenericDataTable<T> {...props} />;
  }
}

function CrudView<T extends Record<string, any>>({
  header,
  mode = "table",
  ...props
}: CrudViewProps<T>) {
  return (
    <div className="mx-auto max-w-full px-0 text-slate-500 gap-10 flex-1 flex flex-col">
      {header ?? <CrudHeader {...props} />}

      <CrudContent<T> mode={mode} {...props} />
    </div>
  );
}

export default CrudView;
